namespace TabAurous.Retail {
    export interface GiftVoucherSalesRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        POSCustomerId?: number;
        CompanyId?: number;
        TotalAmount?: number;
        UserId?: number;
        EmployeeId?: number;
        ItemDetails?: GiftVoucherSalesDetailsRow[];
        ReceiptDetails?: GiftVoucherSalesReceiptRow[];
    }

    export namespace GiftVoucherSalesRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.GiftVoucherSales';
        export const deletePermission = 'Retail:GiftVoucherSales:Delete';
        export const insertPermission = 'Retail:GiftVoucherSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherSales:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            POSCustomerId = "POSCustomerId",
            CompanyId = "CompanyId",
            TotalAmount = "TotalAmount",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            ItemDetails = "ItemDetails",
            ReceiptDetails = "ReceiptDetails"
        }
    }
}
